import "./aboutusourvalues.scss";
import { Link } from "@mui/material";
import React, { useState, useEffect } from "react";
import Dash from "../../components/Dash/Dash";
import {
  CloseIcon,
  Value1Icon,
  Value2Icon,
  Value3Icon,
  Value4Icon,
  Value5Icon,
  Value6Icon,
} from "../../images";
import MetaDecorator from "../../components/MetaDecorator/MetaDecorator";

const AboutUsOurValues = () => {
  const [modalActive, setModalActive] = useState(false);
  const [activeModalIndex, setActiveModalIndex] = useState(null);

  const ourValues = [
    {
      icon: Value1Icon,
      name: "Trust & Collaborative Integrity",
      desc: "We work as one team, united by trust and shared purpose. Trust & Collaborative Integrity means showing up for each other, setting clear & transparent expectations, and creating a safe, inclusive space where every voice is heard. Trust is built through dependable actions, character & competence. We act with honesty, consistency, and mutual respect. We deliver on our commitments and own our mistakes. We succeed when we share accountability, support each other with integrity and live the dictum: “We’re in this together, and your problems are my problems’.",
    },
    {
      icon: Value2Icon,
      name: "Resilience & Determination",
      desc: " Challenges are inevitable – it’s how we respond that defines us. We remain focused and determined, no matter the obstacles. Resilience is not about going it alone but having the organizational and personal agility (prioritizing and reprioritizing) to bouncing back with support, courage, and a solution-oriented mindset.",
    },
    {
      icon: Value3Icon,
      name: "Dependability & Responsibility",
      desc: "We take ownership of our roles and deliver consistently. Being dependable means that others can count on us – we follow through, act responsibly, appreciate interdependency and own outcomes without excuses.",
    },
    {
      icon: Value4Icon,
      name: "Transparency & Clear Communication",
      desc: "We believe that clarity builds confidence. We share relevant information openly and inclusively with all stakeholders, speak clearly, and encourage dialogue to ensure everyone is aligned and informed.",
    },
    {
      icon: Value5Icon,
      name: "Growth Through Strategic Innovation",
      desc: "We are future focused. Strategic innovation means aligning creative ideas with business goals to deliver lasting impact. We challenge the status quo thoughtfully, take smart risks, and view end to end experimentation, across all functions and the entire value chain, as our path to growth. We empower people, don’t just give them the tools and capability.",
    },
    {
      icon: Value6Icon,
      name: "Purposeful Relationships (Internal & External)",
      desc: "We believe strong, meaningful relationships. Our relations with our customers, colleagues, communities, and partners are grounded in respect, empathy, and a shared commitment to growth. Purposeful Relationships means seeing people not as transactions, but as long-term collaborators whose success is linked with ours. We seek to understand their needs deeply, enable their aspirations, and consistently deliver value that exceeds expectations. We strive to be trusted partners who are responsive, reliable, and proactive in enabling others to thrive.",
    },
  ];

  const showModal = (i) => {
    setActiveModalIndex(i);
    setModalActive(true);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  },[]);

  return (
    <>
      <MetaDecorator
        canonicalLink="https://www.sanathan.com/our-values"
        metaTitle="Our Values – Purpose, Integrity & Sustainable Growth – Sanathan Textiles"
        metaDesc="Discover the values that guide Sanathan Textile’s vision to be a trusted global leader in yarn manufacturing, driven by innovation, integrity, and sustainable solutions."
      />
      <section className="our_values_section1">
        <div className="wrapper">
          <div className="breadcrumb_styles">
            <Link to="/" className="breadcrumb_link">
              Home
            </Link>{" "}
            {">"} Our Values
          </div>
          <h1 className="hollow_title">Our Values</h1>
          <div className="dash_wrapper">
            <Dash />
          </div>
          <div className="our_sales_heading">
            <h3 className="sale_text">
              “To be a trusted global leader, shaping the world of fashion and
              performance textiles, through innovative and sustainable
              solutions”
            </h3>
          </div>
        </div>
      </section>
      <section className="our_values_section2">
        <div className="wrapper">
          {ourValues?.map(({ icon, name }, i) => (
            <div className="box" key={`box-${i}`} onClick={() => showModal(i)}>
              <div className="circle">
                <img src={icon} alt={`${name}-icon`} />
              </div>
              <div className="box_name">{name}</div>
            </div>
          ))}
        </div>
      </section>

      {modalActive && (
        <div className="card_modal">
          <div className="wrapper">
            <div className="card_modal_popup">
              <button
                type="button"
                className="our_value_close"
                onClick={() => setModalActive(false)}
              >
                <img src={CloseIcon} alt="Close Icon" />
              </button>
              <div className="modal_heading">
                <h6>{ourValues[activeModalIndex].name}</h6>
              </div>
              <p className="modal_desc">{ourValues[activeModalIndex].desc}</p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AboutUsOurValues;
